"use client";

import { c as _c } from "react/compiler-runtime";
import { fetchAndActivate } from "firebase/remote-config";
import { createContext, useContext, useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
const FirebaseContext = createContext();
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};
const useFirebase = () => {
  const $ = _c(2);
  const context = useContext(FirebaseContext);
  let t0;
  if ($[0] !== context) {
    t0 = {
      ...context
    };
    $[0] = context;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const FirebaseProvider = ({
  children
}) => {
  const [firebaseLoading, setFirebaseLoading] = useState(true);
  const [remoteConfig, setRemoteConfig] = useState(null);
  const initializeFirebase = async () => {
    try {
      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      const rc = getRemoteConfig(app);
      rc.settings.minimumFetchIntervalMillis = 1800000; // 30 minutes

      // Expose immediately; use `getString(rc, key)` from `firebase/remote-config`.
      setRemoteConfig(rc);
      fetchAndActivate(rc).then(() => {
        setFirebaseLoading(false);
      }).catch(error => {
        console.log("Firebase remote config error:", error);
        setFirebaseLoading(false);
      });
    } catch (error) {
      console.log(error);
      setFirebaseLoading(false);
    }
  };
  useEffect(() => {
    // Initialize in the background without blocking rendering
    initializeFirebase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <FirebaseContext.Provider value={{
    firebaseLoading,
    remoteConfig
  }}>
      {children}
    </FirebaseContext.Provider>;
};
export { FirebaseProvider, useFirebase };